import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { useCallback } from 'react';
import { AuthView } from '../auth-view/AuthView';
import { AuthType } from '../auth-view/LazyAuthView.types';

export const DrawerLogin = observer(() => {
  const {
    drawer: { closeDrawer, drawerData },
  } = useStore();

  const afterCompletedAuthentication = useCallback(() => {
    closeDrawer();
  }, []);

  return (
    <View style={{ width: 528, height: '100%', alignItems: 'center', paddingTop: 100 }}>
      <AuthView
        type={AuthType.AUTH}
        afterCompletedAuthentication={afterCompletedAuthentication}
        startingStep={drawerData?.startingStep}
      />
    </View>
  );
});
